import React, { useEffect } from "react";
import { useSignUpForm } from "../../SignUpFormContext";
import { UseFormSetValue } from "react-hook-form";
import { SignUpFormData } from "../../../../SignUpFormTypes/signUpFormTypes";
import ScrollAreaOptions from "../ScrollAreaOptions";
import Check from "../../../../svgs/FilledCheck";

type SelectOptionsType = {
  selected?: string;
  setValue: UseFormSetValue<SignUpFormData>;
  showOptions: (value: boolean) => void;
};

const SelectOptions: React.FC<SelectOptionsType> = ({
  selected,
  setValue,
  showOptions,
}) => {
  const { specialties } = useSignUpForm();

  useEffect(() => {
    selected === "" && setValue("profession", "Select one");
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLLIElement>) => {
    setValue("profession", e.currentTarget.dataset.label ?? "", {
      shouldValidate: true,
      shouldTouch: true,
    });
    setValue("professionId", e.currentTarget.dataset.id ?? "");
  };

  const specialtiesList =
    specialties &&
    specialties.map(({ label, value }) => (
      <li
        className={`${
          label === selected ? "bg-forest-200 font-medium" : "font-normal"
        }
          flex justify-between items-center self-stretch py-2 pr-2 pl-4 hover:bg-forest-200 cursor-pointer`}
        data-label={label}
        data-id={value}
        key={label}
        onClick={handleClick}
      >
        {label}
        {selected === label && (
          <Check className="w-4 h-4" stroke="#123333" background="#DEE3E3" />
        )}
      </li>
    ));

  return (
    <ScrollAreaOptions
      selectOneOption
      selected={selected}
      showOptions={showOptions}
    >
      {specialtiesList}
    </ScrollAreaOptions>
  );
};

export default SelectOptions;
